import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GuidedDiscussionCard = ({ discussion, onStart }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getDifficultyColor = (level) => {
    switch (level) {
      case 'easy':
        return 'success';
      case 'medium':
        return 'warning';
      case 'advanced':
        return 'accent';
      default:
        return 'muted';
    }
  };

  const getDifficultyIcon = (level) => {
    switch (level) {
      case 'easy':
        return 'Smile';
      case 'medium':
        return 'Zap';
      case 'advanced':
        return 'Flame';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-therapeutic transition-therapeutic hover:shadow-therapeutic-lg">
      <div className="p-4 md:p-5 lg:p-6">
        <div className="flex items-start justify-between mb-3 md:mb-4">
          <div className="flex items-start space-x-3 flex-1">
            <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-${getDifficultyColor(discussion?.difficulty)}/10 rounded-md flex-shrink-0`}>
              <Icon 
                name={getDifficultyIcon(discussion?.difficulty)} 
                size={20} 
                color={`var(--color-${getDifficultyColor(discussion?.difficulty)})`}
              />
            </div>
            <div className="flex-1">
              <h3 className="text-base md:text-lg lg:text-xl font-heading font-semibold text-foreground mb-1">
                {discussion?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground line-clamp-2 font-caption">
                {discussion?.description}
              </p>
            </div>
          </div>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="ml-2 p-2 hover:bg-muted rounded-md transition-therapeutic flex-shrink-0"
          >
            <Icon 
              name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
              size={20} 
              color="var(--color-muted-foreground)"
            />
          </button>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-4">
          <span className={`px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-caption font-medium bg-${getDifficultyColor(discussion?.difficulty)}/10 text-${getDifficultyColor(discussion?.difficulty)}`}>
            {discussion?.difficulty}
          </span>
          <span className="px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-caption font-medium bg-muted text-muted-foreground">
            <Icon name="Clock" size={14} color="currentColor" className="inline mr-1" />
            {discussion?.duration}
          </span>
          <span className="px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-caption font-medium bg-muted text-muted-foreground">
            <Icon name="Users" size={14} color="currentColor" className="inline mr-1" />
            {discussion?.participants}
          </span>
        </div>

        {isExpanded && (
          <div className="space-y-4 pt-4 border-t border-border">
            <div>
              <p className="text-sm md:text-base font-medium text-foreground mb-2">
                What You'll Discuss
              </p>
              <ul className="space-y-2">
                {discussion?.topics?.map((topic, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                    <span className="text-sm md:text-base text-muted-foreground">
                      {topic}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-primary/5 border border-primary/20 rounded-md p-3 md:p-4">
              <div className="flex items-start space-x-2">
                <Icon name="Lightbulb" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm md:text-base font-medium text-foreground mb-1">
                    AI Guidance
                  </p>
                  <p className="text-sm md:text-base text-muted-foreground">
                    {discussion?.aiGuidance}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        <Button
          variant="default"
          fullWidth
          onClick={() => onStart(discussion?.id)}
          iconName="Play"
          iconPosition="left"
          className="mt-4"
        >
          Start Guided Discussion
        </Button>
      </div>
    </div>
  );
};

export default GuidedDiscussionCard;